import { prefixWithSeparator as habitatPrefix } from './habitat';
const prefix = `votingPolicyGrants/`;
export const IDToName = ({ habitatID, grantID }) => {
    return habitatPrefix + habitatID + '/' + prefix + grantID;
};
export const nameToID = (name) => {
    const parts = name.split('/');
    if (parts.length !== 4) {
        throw new Error(`bad habitat voting policy grant name: ${name}`);
    }
    return {
        habitatID: parts[1],
        grantID: parts[3],
    };
};
